import type { RefTokenQuery } from "./InvitationTokenProvider.generated.js";

type Contact = Extract<
  RefTokenQuery["crmLinkingInvitation"],
  { __typename: "CrmLinkingInvitation" }
>["contact"];

/** Registration/login prefill for a CRM linking invitation: person fields only when the invitation names a person. */
export function getCrmLinkingInvitationPrefill(contact: Contact) {
  const email: string = contact.email;
  if (!contact.person) return { email };

  return {
    email,
    firstName: contact.person.firstname,
    lastName: contact.person.familyname,
    salutation: contact.person.title,
  };
}
